export default __webpack_public_path__ + "static/media/stageair.ac2996bb.png";